module.exports = __webpack_public_path__ + "static/img/obs.f08896c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/obs.png
// module id = DU7u
// module chunks = 0